module.exports = __webpack_public_path__ + "static/media/logo.d42c74dd.jpg";